export default [
    {
        title: 'Potrebujete peniaze navyše?',
        answers:[{text: 'Áno'},{text: 'Nie'},{text: 'Neviem'}]
    },
    {
        title: 'V prípade, že by ste dostávali 4000-5000 € mesačne, boli by ste ochotní minúť časť týchto peňazí na charitu?',
        answers:[{text: 'Áno'},{text: 'Nie'},{text: 'Neviem'}]
    },
    {
        title: 'Chceli by ste na Váš telefón dostávať finančné bonusy?',
        answers:[{text: 'Áno'},{text: 'Nie'},{text: 'Neviem'}]
    }
]